// UI elementy diskuze a pomocné třídy

// Výchozí třída kometáře
export const COMMENT_CLASS = 'forum__comment';

// Třída pro skrytí tlačítka 'Odpovědět' / 'Zrušit odpověď'
export const CLASS_ACTION_HIDDEN = 'forum__comment-action-reply--hidden';

// Třída pro skrytí tlačítka 'Odpovědět' / 'Zrušit odpověď'
export const CLASS_BUTTON_SHAKED = 'button--shaked';

// Tlačítka 'Další komentáře(n)'
export const buttonsShowMoreComments = (): NodeListOf<HTMLDivElement> =>
  document.querySelectorAll('[data-button-show-more-comments]');

// Tlačítka 'Editovat' v komentářích
export const buttonsEdit: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-edit-comment]');

// Tlačítko 'Zobrazit/skrýt seznam zakázaných výrazů' v administraci
export const buttonToggleBadwords = (): HTMLButtonElement | null =>
  document.querySelector('[data-toggle-bad-words]');

// Tlačítko 'Odeslat komentář' v komentářích
export const buttonAddComment: HTMLButtonElement | null =
  document.querySelector('[data-add-comment]');

// Tlačítka 'Odpovědět' v komentářích
export const buttonsResponse: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-button-reply]');

// Tlačítka 'Smazat/Obnovit příspěvek' v komentářích
export const buttonsDelete: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-delete-comment]');

// Tlačítka 'Nahlásit' v komentářích
export const buttonsNotify: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-notify-comment]');

// Tlačítka 'Nezávadný' v komentářích
export const buttonsHarmless: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-harmless-comment]');

// Tlačítka 'Sdílet' v komentářích
export const buttonsShare: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-share-comment]');

// Tlačítka 'Tleskáček' v komentářích
export const buttonsLike: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-like-comment]');

// Tlačítka 'Výběr redakce' v komentářích | pro administrátory
export const buttonsAdminTip: NodeListOf<HTMLButtonElement> =
  document.querySelectorAll('[data-admin-tip]');

// Formulář pro přidání komentáře
export const formAddComment: HTMLElement | null = document.querySelector('[data-form-add-comment]');

// Textarea pro přidání komentáře
export const textareaAddComment: HTMLTextAreaElement | null =
  document.querySelector('.forum__form-message');

// Modal 'Editovat' komentář
export const modalEdit: HTMLDivElement | null = document.querySelector(
  '[data-modal="edit-comment"]'
) as HTMLDivElement;

// Modal 'Smazat' komentář
export const modalDelete: HTMLDivElement | null = document.querySelector(
  '[data-modal="delete-comment"]'
);

// Modal 'Nahlásit' komentář
export const modalNotify: HTMLDivElement | null = document.querySelector(
  '[data-modal="notify-comment"]'
);

// Modal 'Nezávadný' komentář
export const modalHarmless: HTMLDivElement | null = document.querySelector(
  '[data-modal="harmless-comment"]'
);

// Modal 'Sdílet' komentář
export const modalShare: HTMLDivElement | null = document.querySelector(
  '[data-modal="share-comment"]'
);

// Formulář pro 'Slovník zakázaných výrazů'
export const formBadWords = (): HTMLFormElement | null => document.querySelector('#form_badwords');

// Element pro admin akce
export const adminActionsBar: HTMLElement | null = document.querySelector('.forum__admin-actions');

// Export všech komentář elementů s data atributem 'data-comment-id'
export const allComments: NodeListOf<HTMLDivElement> =
  document.querySelectorAll('[data-comment-id]');

export const allVerticalLines: NodeListOf<HTMLDivElement> = document.querySelectorAll(
  '[data-comment-vertical-line-to]'
);

// Zavře modál pomocí simulovaného kliku na tlačítko, když tlačítko není -> fallback aspoň na schování elementu
export const closeModal = (modal: HTMLElement) => {
    const closeButton = modal.querySelector('[data-modal-close]') as HTMLElement;
    if (closeButton) closeButton.click();
    else modal.style.display = 'none';
}